
import { defineComponent } from 'vue'
import DefaultButton from '@/components/DefaultButton.vue'

export default defineComponent({
  components: { DefaultButton },
  props: {
    textBtn: {
      type: String,
      defalut: ''
    },
    titleEn: {
      type: String,
      defalut: ''
    },
    titleCn: {
      type: String,
      defalut: ''
    },
    description: {
      type: String,
      defalut: ''
    },
    backgroundColorBtn: {
      type: String,
      defalut: ''
    },
    path: {
      type: String,
      defalut: ''
    }
  },
  data() {
    return {
      banner: require('@/assets/images/banner.svg')
    }
  }
})
